const promotionsInitialState = {
  items:              [],
  headItems:          [],
  page:               1,
  limit:              9,
  count:              {},
  article:            {
    buttonLink:        null,
    buttonName:        null,
    contactButtonName: '',
    newsId:            null,
    label:             null,
    headImage:         null,
    content:           null,
    createdAt:         null,
    createdAtIso:      null,
    updatedAtIso:      null,
    readingTime:       null,
    relatedNews:       [],
    meta:              {
      title: null,
      meta:  {
        keywords:    null,
        description: null,
      },
    },
    activeFrom:        null,
    activeTo:          null,
  },
  loading:            false,
  detailLoaded:       false,
  initialStateLoaded: false,
  mainPromotion:      null,
};

export default promotionsInitialState;